import EmailForm from '../emailForm/emailForm';


function ContactUs() {
    return (
        <div id="contactUs">
          <EmailForm />
        </div>
      );
}

export default ContactUs;